// GlobalLoader.js
import React, { createContext, useContext, useState } from "react";

// 1️⃣ Create Loader Context
const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

// 2️⃣ GlobalLoader Component
const LoaderOverlay = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
     backgroundColor: "rgba(255, 255, 255, 1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      flexDirection: "column",
    }}
  >
    <div
      style={{
        border: "6px solid #f3f3f3",
        borderTop: "6px solid yellow",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        animation: "spin 1s linear infinite",
        marginBottom: "12px",
      }}
    ></div>
    <span style={{ fontSize: "16px", fontWeight: "600", color: "black" }}>
      Loading...
    </span>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg);}
        100% { transform: rotate(360deg);}
      }
    `}</style>
  </div>
);

// 3️⃣ Loader Provider
export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const showLoader = () => setLoading(true);
  const hideLoader = () => setLoading(false);

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}
      {loading && <LoaderOverlay />}
    </LoaderContext.Provider>
  );
};
